import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { retrieveAdminStudios } from "./retrieve-admin-studios";
import type { AdminStudioListItem } from "@shared-kernel/application/ports/admin/admin-repository";

const initialState: RetrievalState<AdminStudioListItem[]> = { fetching: "idle", data: [] };

export const retrieveAdminStudiosReducer = createReducer<RetrievalState<AdminStudioListItem[]>>(initialState, builder => {
  builder.addCase(retrieveAdminStudios.fulfilled, (state, { payload }) => {
    return { ...state, data: payload, fetching: "success" };
  });
  builder.addCase(retrieveAdminStudios.pending, state => {
    return { ...state, fetching: "pending" };
  });
  builder.addCase(retrieveAdminStudios.rejected, state => {
    return { ...state, fetching: "failed" };
  });
});
